<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    width="600px"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="100px">

      <el-form-item label="卡号" prop="cardNo">
        <el-input v-model="form.cardNo" @change="cardNoEnv(form.cardNo)" placeholder="请输入卡号，以00开头" v-trim/>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" v-trim/>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <!-- <el-input v-model="form.status" placeholder="请输入状态 0正常 1禁用" v-trim/> -->
        <el-switch
          v-model="form.status"
          :active-value="0"
          :inactive-value="1"
          active-color="#13ce66"
        ></el-switch>
      </el-form-item>

      <!-- <el-form-item label="创建人" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人" v-trim/>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>

      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="form.nickname" placeholder="请输入昵称" v-trim/>
      </el-form-item>
      <el-form-item label="openid" prop="openid">
        <el-input v-model="form.openid" placeholder="请输入openid" v-trim/>
      </el-form-item>

      <el-form-item label="unionid" prop="unionid">
        <el-input v-model="form.unionid" placeholder="请输入unionid" v-trim/>
      </el-form-item>
      <el-form-item label="注册来源 0微信小程序 1支付宝小程序" prop="origin">
        <el-input v-model="form.origin" placeholder="请输入注册来源 0微信小程序 1支付宝小程序" v-trim/>
      </el-form-item>
      <el-form-item label="账户余额（分）" prop="banlance">
        <el-input v-model="form.banlance" placeholder="请输入账户余额（分）" v-trim/>
      </el-form-item>
      <el-form-item label="注册时间" prop="registerDate">
        <el-date-picker v-model="form.registerDate" value-format="yyyy-MM-dd" placeholder="请输入注册时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="最近租车时间" prop="lastRendId">
        <el-date-picker v-model="form.lastRendId" value-format="yyyy-MM-dd" placeholder="请输入最近租车时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" v-trim/>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱" v-trim/>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="form.password" placeholder="请输入密码" v-trim/>
      </el-form-item>

      <el-form-item label="卡密" prop="cardSign">
        <el-input v-model="form.cardSign" placeholder="请输入卡密" v-trim/>
      </el-form-item>
      <el-form-item label="类型 0租客 1管理员" prop="type">
        <el-input v-model="form.type" placeholder="请输入类型 0租客 1管理员" v-trim/>
      </el-form-item>
      <el-form-item label="头像" prop="imgurl">
        <el-input v-model="form.imgurl" placeholder="请输入头像" v-trim/>
      </el-form-item> -->
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaMemberWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        cardNo: '',
        name: '',
        type: '1',
        status: 0
      },
      // 验证规则
      rules: {
        cardNo: [
          { required: true, message: '卡号不能为空！', tigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/member',
      'field.id': 'id'
    })
  },
  methods: {
    cardNoEnv (num) {
      if (!num) return;
      if (String(num).substring(0, 1) !== '0' || String(num).substring(1, 2) !== '0') {
        this.form.cardNo = ''
      }
    }
  }
}
</script>
